export default "/images/6315a3b65905a42a782d5faeda73ba39.avif";